<template>
  <div class="interaction-body display-minimum free-response free-response-display-minimum">
    <div class="px-1rem pb-30 pp-interaction-body">
      <div
        v-for="line in lineArray"
        :key="line"
        class="answer-line"
      ></div>
    </div>
  </div>
</template>

<script>
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'FreeResponseDisplayMinimumInteractionBody',
  mixins: [
    Interaction,
  ],
  data: () => ({
    lineArray: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
    ],
  }),
};
</script>
